"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TimeStamp = exports.Container = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _LocationOn = _interopRequireDefault(require("@material-ui/icons/LocationOn"));

var _color = _interopRequireDefault(require("color"));

var _useEventCallback = _interopRequireDefault(require("use-event-callback"));

var _useToolMode3 = _interopRequireDefault(require("../../hooks/use-tool-mode"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Container = (0, _styles.styled)("div")(function (_ref) {
  var left = _ref.left,
      color = _ref.color,
      hasIcon = _ref.hasIcon;
  return _objectSpread(_objectSpread({
    position: "absolute",
    bottom: 2,
    fontSize: 14,
    fontWeight: 600,
    whiteSpace: "pre"
  }, hasIcon ? {
    left: left - 14,
    bottom: -8,
    padding: 4
  } : {
    borderLeft: "1px solid ".concat(color),
    left: left,
    padding: 4,
    paddingLeft: 6,
    paddingRight: 6,
    backgroundColor: (0, _color.default)(color).darken(0.5).fade(0.2).string()
  }), {}, {
    color: "#fff",
    cursor: "pointer",
    "&:hover": hasIcon ? {
      backgroundColor: (0, _color.default)(color).fade(0.5).string()
    } : {
      backgroundColor: (0, _color.default)(color).darken(0.6).string()
    },
    "& .icon": {
      color: color,
      width: 20,
      height: 20
    },
    "& .stem": hasIcon ? {} : {
      position: "absolute",
      left: -1,
      bottom: -2,
      width: 1,
      height: 2,
      backgroundColor: color
    }
  });
});
exports.Container = Container;

var TimeStamp = function TimeStamp(_ref2) {
  var left = _ref2.left,
      color = _ref2.color,
      label = _ref2.label,
      onClick = _ref2.onClick,
      onRemove = _ref2.onRemove;

  var _useToolMode = (0, _useToolMode3.default)(),
      _useToolMode2 = _slicedToArray(_useToolMode, 1),
      toolMode = _useToolMode2[0];

  var onMouseUp = (0, _useEventCallback.default)(function (e) {
    if (toolMode === "delete" || e.button === 2 || e.button === 1) {
      onRemove();
    }
  });
  var onContextMenu = (0, _useEventCallback.default)(function (e) {
    e.preventDefault();
  });
  return /*#__PURE__*/_react.default.createElement(Container, {
    onClick: onClick,
    onMouseUp: onMouseUp,
    onContextMenu: onContextMenu,
    left: left,
    color: color,
    hasIcon: !label
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "stem"
  }), label ? /*#__PURE__*/_react.default.createElement("span", null, label) : /*#__PURE__*/_react.default.createElement(_LocationOn.default, {
    className: "icon"
  }));
};

exports.TimeStamp = TimeStamp;
var _default = TimeStamp;
exports.default = _default;